import { Component, ElementRef, OnInit, ViewChild } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { ErrorHandlerService } from "../../services/shared/error-handler.service";
import { print_template } from "../../shared/helpers/print_helpers";
import { ReservationService } from "./../../services/reservation-service/reservation.service";
import { ClaimService } from "./claim.service";
import { printClaim } from "./claimPrint";
import { SlimLoadingBarService } from "ng2-slim-loading-bar";
import swal from "sweetalert2";
import { LeadsService } from "../../services/lead-service/lead-service.service";
import { Subscription } from "rxjs";

interface Item {
  groupName: string;
  name: string;
  details: string;
  subItems: { name: string; info: string }[];
  canShow?: boolean;
}

@Component({
  selector: "app-claims-view",
  templateUrl: "./claims-view.component.html",
  styleUrls: ["./claims-view.component.css"],
})
export class ClaimsViewComponent implements OnInit {
  id;

  // view
  balance = 0;
  reservation;
  contractTerms;

  payments;

  // Action Helpers
  selectedClaims = {};

  payments_for_add;
  view = "";
  current_payment;
  add_claim = {
    date: null,
    due_date: null,
    title: "",
    description: "",
    user_id: null,
  };
  accountants;
  claims;
  current_page;
  pageTest: any = 1;
  current_payments;
  current_active_cheque_fine: number;
  collect_type_fines = "fully-collected";
  chequeCollectCustomerFines: any;
  partially_method_fines: any;
  partially_data_fines: any;
  cheque_amount_fines: any;
  currency_code: any = "EGP";
  collection_date_fines = "";

  current_active_cheque: number;
  chequeCollectType: any;
  userProfile: any = JSON.parse(window.localStorage.getItem("userProfile"));

  partially_method: any;
  partially_data: any;
  exchange_rate: any;

  collect_type = "fully-collected";
  collection_date = "";
  chequeRejectType: any;

  // cheques book
  enable_edit_payment_collections = false;
  disableSavePaymentCollection = false;
  check_all = false;
  current_active_full_cheque: any;
  enableRemiderType: string;
  disableReminderType: string;
  chequeCollectCustomer: any;
  cheque_amount;
  transaction_number;
  collectModalSubmitting;
  slip_type: any;

  current_item;
  currencies_list;
  with_holding_tax_percentage;
  cancel_invoice = {
    reason: "",
  };
  holding_tax_percentage = 0;
  itemSub: Subscription;

  @ViewChild("topScroll") topScroll: ElementRef;
  @ViewChild("tableScroll") tableScroll: ElementRef;

  get leadPhones() {
    return [
      this.reservation.sharing_leads[0].lead_phone,
      this.reservation.sharing_leads[0].lead_phone_2,
      this.reservation.sharing_leads[0].lead_phone_3,
      this.reservation.sharing_leads[0].lead_phone_4,
      this.reservation.sharing_leads[0].lead_phone_5,
      this.reservation.sharing_leads[0].lead_phone_6,
    ]
      .filter((a) => a)
      .join(", ");
  }

  constructor(
    private reservationService: ReservationService,
    private claimService: ClaimService,
    private errorHandlerService: ErrorHandlerService,
    private router: Router,
    private route: ActivatedRoute,
    private slimLoadingBarService: SlimLoadingBarService,
    private leadsService: LeadsService
  ) {}

  ngOnInit() {
    this.id = this.route.snapshot.params.id;
    this.getAllCurrencies();
    this.getAgents();
    if (!this.id) {
      this.router.navigate([".."]);
    }
    this.getReservation();
    this.getClaims();
  }

  getAgents() {
    this.accountants = null;
    this.claimService.getAccountants().subscribe(
      (data: any) => {
        this.accountants = data;
      },
      (err) => {
        this.errorHandlerService.handleErorr(err);
      }
    );
  }

  ngAfterViewInit() {}

  makeTableScrollable() {
    setTimeout(() => {
      //console.log(this.topScroll, this.tableScroll);

      // Synchronize scroll between the top scrollbar and the actual table
      this.topScroll.nativeElement.addEventListener("scroll", () => {
        this.tableScroll.nativeElement.scrollLeft =
          this.topScroll.nativeElement.scrollLeft;
      });

      this.tableScroll.nativeElement.addEventListener("scroll", () => {
        this.topScroll.nativeElement.scrollLeft =
          this.tableScroll.nativeElement.scrollLeft;
      });
    }, 1000);
  }

  getReservation() {
    this.reservationService
      .getSingleReservation(this.id)
      .subscribe((res: any) => {
        if (res.data[0]) {
          this.reservation = res.data[0];
          this.payments_for_add = this.reservation.payment_collections.filter(
            (payment) => payment.type === 2
          );
        } else {
          this.router.navigate([".."]);
        }
      });
  }

  getClaims(is_export = false) {
    this.slimLoadingBarService.start();
    this.claimService
      .getReservationStatement(this.id, {
        paginate: "false",
        is_export,
        status: this.view,
      })
      .subscribe(
        (res: any) => {
          this.slimLoadingBarService.complete();
          if (is_export) {
            window.open(res.url, "_blank");
          } else {
            this.balance = res.balance;
            this.payments = res.payments.map((payment) => {
              return {
                ...payment,
                rowSelected: false,
              };
            });
            setTimeout(() => {
              this.makeTableScrollable();
            }, 2000);
          }
        },
        (err) => {
          this.slimLoadingBarService.reset();
          this.errorHandlerService.handleErorr(err);
        }
      );
  }

  getContractTerms() {
    this.reservationService.getContractTerms(this.id).subscribe((res) => {
      this.contractTerms = res;
    });
  }

  deleteClaim(ids) {
    let payload = {
      ids: Array.isArray(ids) ? ids : [ids],
    };
    this.claimService.deleteClaim(this.id, payload).subscribe(
      (res: any) => {
        this.getData();
      },
      (err) => {
        this.errorHandlerService.handleErorr(err);
      }
    );
  }

  sendSelectedToETA() {
    const payments = this.payments.filter((payment) => payment.rowSelected);
    //console.log(payments);
    if (payments.length == 0) {
      swal(
        "No payments selected",
        "Please select payments to send to ETA",
        "error"
      );
      return;
    }
    this.sendToETAExec(payments);
  }

  sendClaimsToSelectedETA(id) {
    const payload = {
      reservation_id: this.id,
      demand_id: id,
    };
    //console.log(payload);
    this.reservationService.sendToETA(payload).subscribe(
      (res: any) => {
        swal("Success", "Payments sent to ETA", "success");
        this.getData();
      },
      (err) => {
        this.errorHandlerService.handleErorr(err);
      }
    );
  }

  sendToETAExec(payments) {
    swal({
      title: "Are you sure?",
      text: "You will send the payments to ETA",
      type: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, send it!",
      cancelButtonText: "No, keep it",
    }).then((result) => {
      if (result.value) {
        const payload = {
          reservation_id: this.id,
          payments: payments.map((payment) => {
            return {
              id: payment.id,
              type: payment.type,
            };
          }),
        };
        //console.log(payload);
        this.slimLoadingBarService.start();
        this.reservationService.sendToETA(payload).subscribe(
          (res: any) => {
            swal("Success", "Payments sent to ETA", "success");
            this.getData();
            this.slimLoadingBarService.complete();
          },
          (err) => {
            this.slimLoadingBarService.reset();
            this.errorHandlerService.handleErorr(err);
          }
        );
      } else if (result.dismiss) {
        swal("Cancelled", "", "error");
      }
    });
  }

  approveClaims({ id }) {
    const payload = {
      reservation_id: this.id,
      ids: [id],
      status: "approve",
    };
    this.reservationService.approveClaims(payload).subscribe(
      (res: any) => {
        swal("Success", "Claims Approved", "success");
        this.getClaimsTab();
      },
      (err) => {
        this.errorHandlerService.handleErorr(err);
      }
    );
  }

  rejectClaims({ id }) {
    const payload = {
      reservation_id: this.id,
      ids: [id],
      status: "reject",
    };
    this.reservationService.approveClaims(payload).subscribe(
      (res: any) => {
        swal("Success", "Claims rejected", "success");
        this.getClaimsTab();
      },
      (err) => {
        this.errorHandlerService.handleErorr(err);
      }
    );
  }

  // table selects
  selectAll(value) {
    this.payments.forEach((payment) => {
      payment.rowSelected = value;
    });
  }

  selectAllClaims(value) {
    this.claims.data.forEach((payment) => {
      payment.rowSelected = value;
    });
  }

  getSelected(filterFunction = () => true) {
    return this.payments
      .filter((payment) => payment.rowSelected)
      .filter(filterFunction);
  }

  // helpers
  printStatement() {
    let payments = this.getSelected();
    print_template(printClaim, this.reservation, payments);
  }

  getClaimsSelected(filterFunction = () => true) {
    const selectedClaims = this.claims.data
      .filter((payment) => payment.rowSelected)
      .filter(filterFunction);
    const payments = [];
    selectedClaims.forEach((claim) => {
      payments.push(...claim.payments);
    });
    return payments;
  }

  printStatementForClaims() {
    let payments = this.getClaimsSelected();
    //console.log(payments);
    print_template(printClaim, this.reservation, payments);
  }

  setView(view) {
    this.view = view;
    this.payments = null;
    this.balance = null;
    this.getData();
  }

  getData() {
    if (this.view !== "claims") {
      this.getClaims();
      return;
    }
    this.getClaimsTab();
  }

  getMethodName(method) {
    switch (method) {
      case "1":
        return "Cash";
      case "2":
        return "Visa";
      case "3":
        return "Bank Transfer";
      case "4":
        return "Cheque";
      default:
        return "N/A";
    }
  }

  data: Item[] = [
    {
      groupName: "Group A",
      name: "Item 1",
      details: "More information about Item 1",
      subItems: [
        { name: "Sub-Item 1", info: "Info 1" },
        { name: "Sub-Item 2", info: "Info 2" },
      ],
    },
    {
      groupName: "Group B",
      name: "Item 2",
      details: "More information about Item 2",
      subItems: [
        { name: "Sub-Item 1", info: "Info 1" },
        { name: "Sub-Item 2", info: "Info 2" },
      ],
    },
  ];

  expandedElement: Item | null = null;

  toggleRow(item: any): void {
    // this.expandedElement = this.expandedElement === item ? null : item;
    if (item.is_expanded) {
      this.expandedElement = null;
      item.is_expanded = false;
      return;
    }
    if (this.itemSub) {
      this.itemSub.unsubscribe();
      this.claims.data.forEach((payment) => {
        payment.is_expanded = false;
        payment.loading = false;
      });
    }
    item.loading = true;
    this.slimLoadingBarService.start();
    this.itemSub = this.claimService
      .getItemDetails(item.id)
      .subscribe((res: any) => {
        item.loading = false;
        this.slimLoadingBarService.complete();
        item.payments = res.payments;
        this.expandedElement = this.expandedElement === item ? null : item;
        item.is_expanded = true;
      });
  }

  openMakeClaim(payment, claimModal) {
    this.current_payment = payment;
    claimModal.open();
  }

  getClaimsTab() {
    this.slimLoadingBarService.start();
    this.claimService.getClaimsTab(this.id).subscribe(
      (res: any) => {
        this.claims = {
          ...res,
          data: res.data.map((claim) => ({
            ...claim,
            rowSelected: false,
          })),
        };
        this.slimLoadingBarService.complete();
      },
      (err) => {
        this.slimLoadingBarService.reset();
        this.errorHandlerService.handleErorr(err);
      }
    );
  }

  assignClaimsModalOpen(current_item, modal) {
    this.current_item = current_item;
    //console.log(this.current_item);
    modal.open();
  }

  getAllCurrencies() {
    this.slimLoadingBarService.start();
    this.reservationService.getAllCurrencies().subscribe(
      (data: any) => {
        this.currencies_list = data;
      },
      (err) => this.errorHandlerService.handleErorr(err),
      () => this.slimLoadingBarService.complete()
    );
  }

  createClaimModalSubmit(modal) {
    let payload = {
      ...this.add_claim,
      ids: null,
      reservation_id: this.id,
    };
    if (this.current_payment) {
      payload.ids = [
        {
          id: this.current_payment.id,
          type: this.current_payment.type,
        },
      ];
    } else {
      payload.ids = this.payments
        .filter((payment) => payment.rowSelected)
        .map((payment) => {
          return {
            id: payment.id,
            type: payment.type,
          };
        });
    }
    this.claimService.createClaim(payload).subscribe(
      (res: any) => {
        this.getData();
        this.add_claim = {
          date: null,
          due_date: null,
          title: "",
          description: "",
          user_id: null,
        };
        swal("Success", "claim created successfully", "success");
        modal.close();
        this.getData();
      },
      (err) => {
        this.errorHandlerService.handleErorr(err);
      }
    );
  }

  infinite(url, number) {
    this.slimLoadingBarService.start();
    this.leadsService.infinit(url).subscribe(
      (data: any) => {
        this.claims = data;
        this.current_page = number;
        this.slimLoadingBarService.complete();
      },
      (err) => {
        this.errorHandlerService.handleErorr(err);
        this.slimLoadingBarService.reset();
      }
    );
  }

  pageChange(event) {
    let arr = this.claims.last_page_url.split("?");
    let selectedUrl = `${arr[0]}?page=${event}`;
    this.infinite(selectedUrl, event);
  }

  openMakeClaimMulti(modal) {
    this.current_payment = null;
    modal.open();
  }

  assignClaimModal(modal) {
    //console.log(this.current_payments);
    let payload = {
      reservation_id: this.id,
      user_id: this.add_claim.user_id,
      ids: [this.current_item.id],
    };
    this.slimLoadingBarService.start();
    this.claimService.assignClaim(payload).subscribe(
      (res) => {
        this.slimLoadingBarService.complete();
        swal("Success", "Claims Assigned", "success");
        modal.close();
        this.getData();
      },
      (err) => {
        this.slimLoadingBarService.reset();
      }
    );
  }

  viewETAClaims(item) {
    this.router.navigateByUrl(
      `/pages/financial/claims/${this.id}/eta-view/${item.id}`
    );
  }

  deleteDemand(id) {
    swal({
      title: "Are you sure?",
      text: "You will delete it!",
      type: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "No, keep it",
    }).then((result) => {
      if (result.value) {
        this.slimLoadingBarService.start();
        this.claimService.deletePayment(id).subscribe(
          (data) => {
            swal("Done!", "Deleted successfully!", "success");
            this.getData();
          },
          (err) => this.errorHandlerService.handleErorr(err),
          () => this.slimLoadingBarService.complete()
        );
      }
    });
  }

  submitCollectCheque(modal) {
    if (this.currency_code != "EGP" && !this.exchange_rate) {
      swal(
        "error",
        "Exchange Rate is needed if the currency is not EGP",
        "error"
      );
      return;
    }
    let payload: any = {
      ids: [this.current_active_cheque],
      status: this.collect_type,
      lead_id: this.chequeCollectCustomer,
      partially_method: this.partially_method,
      collection_date: this.collection_date,
      exchange_rate: this.exchange_rate,
      currency_code: this.currency_code,
    };
    if (this.collect_type == "partially-collected") {
      payload.amount_received = this.cheque_amount;
      if (payload.partially_method == "3") {
        payload.partially_data = this.partially_data;
      }
    }
    if (
      this.collect_type === "partially-collected" &&
      this.partially_method != 4
    ) {
      payload.transaction_number = this.transaction_number;
    }
    if (this.isDateGreaterThanToday(this.collection_date)) {
      swal("collection date can not be greater than today", "", "error");
      return;
    }
    if (this.slip_type === "2" || this.slip_type === "3") {
      if (!this.transaction_number) {
        swal("error", "Transaction Number is required", "error");
        return;
      }
    }
    payload.holding_tax_percentage = this.holding_tax_percentage;
    this.collectModalSubmitting = true;
    this.slimLoadingBarService.start();
    this.reservationService
      .collectCheque(this.id, payload)
      .subscribe(
        (res: any) => {
          swal("Woohoo!", "Collected!", "success");
          modal.close();
          this.collect_type = null;
          this.current_active_cheque = null;
          this.cheque_amount = null;
          this.partially_method = null;
          this.partially_data = null;
          this.collection_date = "";
          this.chequeCollectCustomer = "";
          this.getReservation();
          this.getData();
        },
        (err) => {
          this.errorHandlerService.handleErorr(err);
        }
      )
      .add(() => {
        this.collectModalSubmitting = false;
      });
  }

  onOpenCollectCheque(id, modal, type?) {
    if (id) this.current_active_cheque = id;
    if (type) this.chequeCollectType = type;
    else this.chequeCollectType = null;
    //console.log(this.chequeCollectType);
    modal.open();
  }

  isDateGreaterThanToday(date) {
    const inputDate = new Date(date);
    const today = new Date();

    if (inputDate > today) {
      return true;
    }
    return false;
  }

  printPdf(pdf_url) {
    window.open(pdf_url, "_blank");
  }

  openHoldingTaxModal(modal, list) {
    modal.open();
    this.current_active_full_cheque = list;
  }

  submitWithHoldingPercentage(modal) {
    const payload = {
      percentage: this.with_holding_tax_percentage,
      ids: [this.current_active_full_cheque.id],
    };
    this.slimLoadingBarService.start();
    this.reservationService.addHoldingTax(this.id, payload).subscribe(
      (res) => {
        swal("Success!", "with holding tax added successfully", "success");
        this.slimLoadingBarService.complete();
        modal.close();
        this.getData();
      },
      (err) => {
        this.slimLoadingBarService.complete();
        modal.close();
      }
    );
  }

  openCancelInvoiceModal(payment, cancelInvoiceModal) {
    this.current_payment = payment;
    cancelInvoiceModal.open();
  }

  submitCancelInvoice(cancelInvoiceModal) {
    const payload = {
      ...this.cancel_invoice,
      id: this.current_payment.id,
      type: this.current_payment.type,
    };
    this.slimLoadingBarService.start();
    this.reservationService.cancelInvoice(payload).subscribe(
      (res: any) => {
        this.slimLoadingBarService.complete();
        cancelInvoiceModal.close();
        this.getData();
        swal("Woohoo!", "Cancel Invoice created succesfully!", "success");
      },
      (err) => {
        this.slimLoadingBarService.reset();
        this.errorHandlerService.handleErorr(err);
      }
    );
  }

  makeCreditNote(payment) {
    //console.log(this.id);
    this.slimLoadingBarService.start();
    const payload = {
      id: payment.id,
      type: payment.type,
      reservation_id: this.id,
    };
    this.reservationService.makeCreditNote(payload).subscribe(
      (res: any) => {
        this.slimLoadingBarService.complete();
        this.getData();
        swal("Woohoo!", "Credit Note created succesfully!", "success");
      },
      (err) => {
        this.slimLoadingBarService.reset();
        this.errorHandlerService.handleErorr(err);
      }
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/financial/claims-view/claims-view.component.ts